/**
 * Comparable-based valuation API.
 *
 *   POST /api/v1/smt/valuation        (level≥1, admin bypass)
 *
 * Region scope is enforced server-side for level=1 callers; the frontend
 * relies on backend 403 responses rather than re-implementing the check.
 */
import { requestData } from './client.ts';
import type { Valuation, ValuationRequest } from '../types/api.ts';

export async function estimate(req: ValuationRequest): Promise<Valuation> {
  return requestData<Valuation>('/smt/valuation', {
    method: 'POST',
    body: req,
  });
}
